import { Alert } from 'antd';
import { generateAlertMessage } from './generate-alert-message';
import type { TVehicleDetails } from './types';

export const VehicleAlert: React.FC<TVehicleDetails> = (props) => {
  const { inService, needService, plateNumber, serviceComment } = props;

  if (!inService && !needService) return null;

  const message = generateAlertMessage({
    plateNumber,
    inService,
    needService,
    serviceComment,
  });

  return <Alert style={{ whiteSpace: 'pre-line' }} message={message} type='warning' />;
};
